import products from './products.js'
import services from './services.js'
import categories from './categories.js'
import attributes from './attributes.js'
import variants from './variants.js'

export default {
  menu: 'Products & Services',

  products,
  services,
  categories,
  attributes,
  variants
}
